module.exports = __webpack_public_path__ + "e8790b866d054ba7b7b4e19e6ae75ed8.svg";